import React, {useState, useEffect} from "react";
import "./ConsultantStatsBar.css";
import speedometerData from "../../assets/animations/speedometer.json";
import Lottie from "react-lottie";
import {consultantService} from "../../services/consultant.service";
import {Tooltip} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";

export default function ConsultantStatsBar(props) {
  const [stopAnimation, setStopAnimation] = useState(true);
  const [notSentTotal, setNotSentTotal] = useState(0);
  const [sent, setSent] = useState(0);
  const [notSentGroups, setNotSentGroups] = useState([]);
  const [comission, setComission] = useState(0);

  const numberFormatter = value => `${`${value}`.replace(/(\d)(?=(\d{3})+$)/g, "$1.")}`;

  const stopTimes = {
    red: 250,
    orange: 460,
    yellow: 700,
    green: 4000
  };

  const getStatistics = async () => {
    const result = await new consultantService().getStatistics();
    console.log(result);
    setNotSentTotal(result.data.notSentTotal);
    setNotSentGroups(result.data.notSentGroups);
    setSent(result.data.formsSent);
    setComission(result.data.comission);
    let timer = "red";
    if (result.data.formsSent > 4500) timer = "green";
    if (result.data.formsSent < 4500) timer = "yellow";
    if (result.data.formsSent < 2300) timer = "orange";
    if (result.data.formsSent < 1500) timer = "red";
    stopAnimationAtSpecificTime(stopTimes[timer]);
  };

  const generateGroups = () => {
    return notSentGroups.map((el, idx) => (
      <p className="stat-groups-p" key={"statgroup-" + idx}>
        <span style={{color: "grey"}}>G-{el.group_name}:</span> <span style={{fontWeight: "bolder", color: "#000000"}}>{numberFormatter(el.total)}</span>
      </p>
    ));
  };

  useEffect(() => {
    getStatistics();
  }, []);

  const stopAnimationAtSpecificTime = time => {
    setStopAnimation(false);
    setTimeout(() => {
      setStopAnimation(true);
    }, time);
  };

  const defaultOptions = {
    loop: true,
    autoplay: false,
    animationData: speedometerData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
  return (
    <div id="main-stats-box">
      <div
        style={{
          height: "100%",
          width: "20vw"
        }}
        className="statBox"
      >
        <div
          style={{
            paddingTop: "15px",
	          paddingLeft: "15px",
          }}
        >
	        <p
		        style={{
			        backgroundColor: "orange",
			        color: "white",
			        paddingTop: "4px",
			        paddingBottom: "4px",
			        paddingRight: "10px",
			        paddingLeft: "10px",
			        display: "inline",
			        borderRadius: "20px"
		        }}
	        >
		        Nicht bearbeitet
	        </p>
          <h2
            style={{
              marginTop: "5px",
              fontWeight: "bolder",
              fontSize: "45px",
              marginBottom: "0"
            }}
          >
            {numberFormatter(notSentTotal)}
          </h2>
          <h4 style={{color: "grey", marginTop: "6px"}}>Gesamt</h4>
        </div>
      </div>
      <div
        style={{
          height: "100%",
          width: "30vw"
        }}
        className="statBox"
      >
        <div style={{padding: "15px"}}>
	        <p
		        style={{
			        backgroundColor: "orange",
			        color: "white",
			        paddingTop: "4px",
			        paddingBottom: "4px",
			        paddingRight: "10px",
			        paddingLeft: "10px",
			        display: "inline",
			        borderRadius: "20px"
		        }}
	        >
		        Nicht bearbeitet
	        </p>
	        <div style={{paddingLeft: "5px"}} id="stat-groups">{generateGroups()}</div>
        </div>
      </div>
	    <Tooltip title={"Gesendet: " + sent}>
		    <div
			    style={{
				    height: "100%",
				    width: "15vw",
				    position: "relative",
				    justifyContent: "flex-start",
				    padding: "15px"
			    }}
			    className="statBox"
		    >
			    <Lottie isClickToPauseDisabled={true} options={defaultOptions} height={120} width={190} isPaused={stopAnimation} />
          <p style={{margin: 0, color: "grey", textAlign: "center"}}>Speed - Parameter</p>
        </div>
      </Tooltip>
      <div
        style={{
          height: "100%",
          width: "15vw"
        }}
        className="statBox"
      >
	      <div style={{
		      paddingTop: "15px",
		      paddingLeft: "15px"
		  }}>
		      <p
			      style={{
				      backgroundColor: "mediumseagreen",
				      color: "white",
				      paddingTop: "4px",
				      paddingBottom: "4px",
				      paddingRight: "10px",
				      paddingLeft: "10px",
				      display: "inline",
				      borderRadius: "20px"
			      }}
		      >
			      Geschätzter Umsatz{" "}
			      <Tooltip
				      title={
					      <p>
						      Die Schätzung folgt der Formel: <br/>{" "}
						      <span style={{fontWeight: "bold"}}>
                    Pro abgeschicktem Formular = <br/> 5€ * geschätzte Wahrscheinlichkeit Annahmequote vom Finanzamt in %
                  </span>
					      </p>
				      }
			      >
				      <InfoCircleOutlined/>
			      </Tooltip>
		      </p>
		      <h2
			      style={{
				      marginTop: "5px",
				      fontWeight: "bolder",
				      fontSize: "45px",
				      marginBottom: "0"
			      }}
		      >
			      {numberFormatter(comission.toFixed(2))} €
		      </h2>
		      <h4 style={{color: "grey", marginTop: "6px"}}>Diese Woche</h4>
	      </div>
      </div>
    </div>
  );
}
